import axios, { AxiosResponse } from 'axios'
import { BaseDataObject } from '../apis/ApiBase'
// import store from '../store'
import router from '../router'
import { Toast } from '@/components/Toast'


export const urls = (process.env.NODE_ENV === 'development' ? {
  //baseUrl: "https://www.umiblog.cn/api/ppy"
  baseUrl: "https://ppy.ippyu.com/api/ppy"
} : {
  // baseUrl: "https://www.umiblog.cn/api/ppy"
  baseUrl: "https://ppy.ippyu.com/api/ppy"
})

axios.defaults.baseURL = urls.baseUrl

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  // 附加参数router.currentRoute.value.query
  let  query = router.currentRoute.value.query;
  if(localStorage.getItem("ticket")){
    query =Object.assign(query,{ticket:localStorage.getItem("ticket")});
  }else{
    localStorage.setItem("ticket",String(router.currentRoute.value.query.ticket))
    query = router.currentRoute.value.query;
  }
  if(localStorage.getItem("parent")){
    query = Object.assign(query,{parent:localStorage.getItem("parent")});
  }else{
    if(router.currentRoute.value.query.parent){
      localStorage.setItem("parent",String(router.currentRoute.value.query.parent))
    }
    query = Object.assign(query,router.currentRoute.value.query);
  }
  
  config.params = Object.assign({}, query, config.params, {
    t: Math.random()
  })
  if (config.params['noLoading']) {
    delete config.params['noLoading']
    return config
  }
  return config
})

axios.interceptors.response.use((response: AxiosResponse<BaseDataObject>) => {
  // 如果请求的域名不是我要的，那就放行到下一个拦截器
  if (response.config.url?.startsWith('http')) return response
  const data = response.data
  if (data.status == 0) {
    return response
  }else if(data.status === 100001){
    localStorage.removeItem("ticket")
    if(router.currentRoute.value.query.parent){
      if(router.currentRoute.value.name === "EleMent"){
        window.location.href = urls.baseUrl+"/miniprogram/wechat/mlfp/preJump?parent="+router.currentRoute.value.query.parent+"&router="+router.currentRoute.value.name
      }else{
        window.location.href = urls.baseUrl+"/miniprogram/wechat/mlfp/preJump?parent="+router.currentRoute.value.query.parent
      }
      
    }else{
      if(router.currentRoute.value.name === "EleMent"){
        window.location.href = urls.baseUrl+"/miniprogram/wechat/mlfp/preJump?router="+router.currentRoute.value.name
      }else{
        window.location.href = urls.baseUrl+"/miniprogram/wechat/mlfp/preJump"
      }
      
    }
   
  }
  Toast.toast(data.view)
  return Promise.reject(new Error(data.view))
}, error => {
  Toast.toast('登录信息授权中......')
  return Promise.reject(error)
})
